import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { TweenLite, Power2 } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
const plugins = [ScrollToPlugin];

const tooltipRoot = document.querySelector('.tooltip-root');

class TooltipPortal extends Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
		this.el.classList.add('tooltip-container');
		if (this.props.align) {
			this.el.classList.add(`align-${this.props.align}`);
		}
	}

	componentDidMount() {
		tooltipRoot.appendChild(this.el);
	}

	componentWillUnmount() {
		tooltipRoot.removeChild(this.el);
	}

	componentDidUpdate() {
		if (this.props.active) {
			this.el.classList.add('active');
			this.el.style.top = `${this.props.coords.top}px`;
			this.el.style.left = `${this.props.coords.left}px`;
		} else {
			this.el.classList.remove('active');
		}
	}

	render() {
		return ReactDOM.createPortal(this.props.children, this.el);
	}
}

class Tooltip extends Component {
	constructor(props) {
		super(props);
		this.state = { active: false, coords: null };
		this.iconRef = React.createRef();
		this.scrollContainer = null;
	}

	componentDidUpdate() {
		if (!this.scrollContainer && this.props.scrollContainer) {
			this.scrollContainer = this.props.scrollContainer;
		}
	}

	openTooltip = () => {
		const coords = this.iconRef.current.getBoundingClientRect();
		this.setState({ active: true, coords });
		window.addEventListener('scroll', this.handleContainerScroll);
		window.addEventListener('click', this.closeTooltip);
		if (this.scrollContainer) {
			this.scrollContainer.addEventListener('scroll', this.handleContainerScroll);
		}
	};

	closeTooltip = () => {
		this.setState({ active: false });
		window.removeEventListener('scroll', this.handleContainerScroll);
		if (this.scrollContainer) {
			this.scrollContainer.removeEventListener('scroll', this.handleContainerScroll);
		}
	};

	handleContainerScroll = () => {
		this.closeTooltip();
	};

	scrollToTop = () => {
		return new Promise((resolve) => {
			if (this.scrollContainer) {
				TweenLite.to(this.scrollContainer, 0.25, {
					scrollTo: { y: '.single-updated-date', offsetY: 250 },
					easing: Power2.easeInOut,
					onComplete: () => resolve(),
				});
			} else {
				resolve();
			}
		});
	};

	handleTouchStart = async () => {
		//await this.scrollToTop();
		setTimeout(() => {
			this.openTooltip();
		}, 25);
	};

	render() {
		const { children, align } = this.props;
		return (
			<div className={'tooltip'}>
				<div className="tooltip__icon" ref={this.iconRef}>
					<span
						className="icon icon-info"
						onTouchStart={this.handleTouchStart}
						onMouseOver={this.openTooltip}
						onMouseLeave={this.closeTooltip}
					/>
				</div>
				<TooltipPortal
					active={this.state.active}
					coords={this.state.coords}
					align={align}
					scrollOffset={this.state.scrollOffsetAmount}
				>
					{children}
				</TooltipPortal>
			</div>
		);
	}
}

Tooltip.defaultProps = {
	align: 'right',
};

export default Tooltip;
